// Runtime asset-host override.
//
// The Python exporter writes per-camera mp4 (and splat) URLs into the bundle.
// Two shapes occur in the wild:
//   - ABSOLUTE  (e.g. "https://multipose-media.pentacoxian.dev/long360/...")
//     when exported with --asset-base-url; works anywhere as-is.
//   - RELATIVE  (e.g. "../long360/view_000.mp4") when exported for local dev;
//     resolves to the symlinked public/long360 under `npm run dev`, but BREAKS
//     in the built/deployed bundle, where long360/ is stripped (mp4s live on
//     R2 instead) — yielding "video load failed: ../long360/view_000.mp4".
//
// `?asset_base=<host>` lets a deployed page point a relative-URL bundle at R2
// without re-exporting (the escape hatch DEPLOY.md documents). When set, any
// relative asset URL is re-rooted onto that host by its trailing path segments
// (the leading "../" / "/" hops are dropped — only the meaningful tail like
// "long360/view_000.mp4" is kept).

/** The ?asset_base= value for this page load, or null. Trailing slash trimmed. */
export function getAssetBase(): string | null {
  const v = new URLSearchParams(location.search).get("asset_base");
  return v ? v.replace(/\/+$/, "") : null;
}

/** True for "http(s)://…" and protocol-relative "//…" URLs (already hostable). */
function isAbsolute(url: string): boolean {
  return /^(https?:)?\/\//i.test(url);
}

/**
 * Resolve one asset URL against the active ?asset_base= override.
 *
 * - Absolute URLs are returned untouched (the export already baked the host in).
 * - With no override, relative URLs are returned untouched (dev keeps working).
 * - With an override, a relative URL's leading "../"/"/" hops are stripped and
 *   the remaining tail is appended to the base host:
 *     "../long360/view_000.mp4" + base "https://cdn" -> "https://cdn/long360/view_000.mp4"
 */
export function resolveAssetUrl(url: string, base = getAssetBase()): string {
  if (!url || isAbsolute(url) || !base) return url;
  const tail = url.replace(/^(\.\.\/|\.\/|\/)+/, "");
  return `${base}/${tail}`;
}
